import React, { Component, createRef } from "react";
import { Redirect } from "react-router-dom";
import AppDndProvider from "../providers/AppDndProvider";
import Header from "../components/@header/header";
import LeftNav from "../components/@leftNav/leftNav";
import DoubleSentence from "../templates/DoubleSentence";
import IrregularVerbsTestYourself from "../templates/IrregularVerbsTestYourself";
import Mosaic from "../templates/Mosaic";
import DoubleSentenceHL from "../templates/doubleSentenceHighlighted/DoubleSentenceHL";
import TextPagesHL from "../templates/TextPagesHL";
import SimpleTextHL from "../templates/simpleTextHighLighted/SimpleTextHL";
import SpeakRightSingle from "../templates/SpeakRightSingle";
import SpeakRightDouble from "../templates/SpeakRightDouble";
import SimpleSentence from "../templates/simpleSentence/SimpleSentence";
import SimpleSentenceVr from "../templates/simpleSentenceVoiceRecognition/SimpleSentenceVoiceRecognition";

import SingleCard from "../templates/SingleCard";
import LinkingSounds from "../templates/LinkingSounds";
import {
  getPrePostVideo,
  getLessonContent,
  createUsage,
  updateUsage,
  registerCompleteness,
} from "../service/service";
import IrregularVerbs from "../templates/IrregularVerbs";
import IrregularVerbs3 from "../templates/IrregularVerbs3";
import WordsInContext from "../templates/WordsInContext";
import ConversationInTrio from "../templates/ConversationInTrio";
import WebTalk from "../templates/WebTalk";
import ConversationInTwo from "../templates/ConversationInTwo";
import FluencyInPairs from "../templates/FluencyInPairs";
import Carousel from "../templates/Carousel";
import ImageAudio from "../templates/imageAudio/ImageAudio";
import TextPagesIllustrated from "../templates/TextPagesIllustrated";
import ReadMatch from "../templates/ReadMatch";
import ListenMatch from "../templates/ListenMatch";
import Match from "../templates/match/Match";
import PrePost from "../templates/PrePost";
import Audio from "../templates/audio/Audio";
import TextPagesScrambled from "../templates/TextPagesScrambled";
import Workbook from "../templates/Workbook";
import DialogRolePlay from "../templates/DialogRolePlay";
import ListenAndDragToPutInOrder from "../templates/listenAndDragToPutInOrder/ListenAndDragToPutInOrder";
import Song from "../templates/Song";
import Maze from "../templates/Maze";
import EndLesson from "../templates/EndLesson";
import ImageSubtitle from "../templates/ImageSubtitle/ImageSubtitle";
import DoubleSentenceStatic from "../templates/DoubleSentenceStatic/DoubleSentenceStatic";
import SentencesList from "../templates/sentenceList/SentencesList";
import ListenAndChoose from "../templates/ListenAndChoose";
import TextDialogDnD from "../templates/TextDialogDnD";
import LeadInText from "../templates/LeadInText";
import MatchSentences from "../templates/matchTheSentences/MatchTheSentences";
import ChooseCorrectAnswer from "../templates/ChooseCorrectAnswer";
import ImagePhraseType from "../templates/imagePhraseType/ImagePhraseType";
import VideoSubtitle from "../templates/VideoSubtitle";
import FillTheBlank from "../templates/FillTheBlank";
import { getUserEmail, getUserId, getWizmeId } from "../helpers/user";
import { getUsageWithFallback } from "../helpers/progressFallback";

import noContentIllustration from "../assets/images/no-content-lesson.png";
import styles from "./exercises.module.css";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ArrowUturnLeftIcon } from "../assets/icons/ArrowUturnLeft";

import ModalFeedback from "../containers/modalFeedback/modalFeedback";

import { AppGlobalConfigContext } from "../providers/AppGlobalConfigContext";
import PutInOrderWord from "../templates/putInOrderWord/PutInOrderWord";
import LessonLoader from "../components/LessonLoader/LessonLoader";
import Footer from "../components/footer/Footer";
import { getAudioUrl, isSafariOrIOS } from "../lib/utils";
import LessonStateContext from "../context/LessonStateContext";
import TextIllustrated from "../templates/textIllustrated/TextIllustrated";

const MOSAIC_TEMPLATES = [
  "mosaic_en",
  "mosaic_pt",
  "mosaic_2_en",
  "mosaic_2_pt",
];

const DISABLED_KEEP_AND_PLAY_TEMPLATES = [
  "listen_and_drag_to_put_in_order",
  "fill_the_blank",
  "choose_correct_answer",
  "lead_in_text",
  "maze",
  "match_the_sentences",
  "text_pages_scrambled",
  ...MOSAIC_TEMPLATES,
  "match",
  "listen_and_choose",
  "put_in_order_word_sentences",
  "put_in_order_words_sentences",
  "read_and_match",
  "text_dialogue_drag_drop",
  "simple_sentence_vr",
];

const NOT_SKIP_FORWARD_TEMPLATES = [
  "listen_and_drag_to_put_in_order",
  "fill_the_blank",
  "choose_correct_answer",
  "lead_in_text",
  "maze",
  "match_the_sentences",
  "text_pages_scrambled",
  ...MOSAIC_TEMPLATES,
  "match",
  "listen_and_choose",
  "put_in_order_word_sentences",
  "put_in_order_words_sentences",
];

class Exercises extends Component {
  static contextType = AppGlobalConfigContext;

  constructor(props) {
    super(props);

    this.state = {
      video: 0,
      blockIndex: this.props.match.params.block,
      contentIndex: 0,
      isPlaying: false,
      audioUrl: "",
      preVideoId: "",
      isLoading: false,
      VideoIsLoading: false,
      lessonId: this.props.match.params.lessonId,
      lessonLoading: true,
      lessonContent: {},
      lessonError: false,
      endLesson: false,
      specificUrl: null,
      forceAudio: false,
      forceComplent: false,
      indexComplent: -1,
      checked: false,
      recordingAttempts: 0,
      vrError: false,
      bookId: 0,
      usage: null,
      // states to control Instant Feedback
      instantFeedback: {
        previousBlockIndex: null,
        previousTemplate: "",
        enableTemplates: ["simple_sentence_vr"],
        modalFeedbackProps: {
          mwShow: false,
          mwClickOutsideToClose: true,
          instantFeedbackData: {},
        },
      },
      batch: null,
      batchProgress: null,
      calledCompletenessCheckOnEndLesson: false,
      updatedProgressTrackerUsageOnEndLesson: false,
      sectionsTotal: 0,
      subSectionsTotal: 0,
    };
  }
  setChecked = (isChecked) => {
    this.setState({
      checked: isChecked,
    });
  };

  setForceAudio = () => {
    this.setState({
      forceAudio: true,
      contentIndex: 1,
      audioUrl: "", // Reset the audio to avoid to play again, on the next rendering, it is computed based on the neu contentIndex and blockIndex
    });
  };

  async getVideo(lessonId, backboneResponse) {
    return getPrePostVideo(lessonId)
      .then((response) => response.data)
      .then((response) => {
        const lessonBlocks = backboneResponse.blocks;
        // if the video exists then it will be a prePost_video
        if (response.length > 0 && response[0].video_kind === "1") {
          var pre_video_id = response[0].video_id;

          lessonBlocks.unshift({
            block_id: 0,
            complement: {},
            content: [
              {
                sound: null,
                en: "",
                pt: "",
                id: 0,
                instruction: "Pre Video",
                duration: 1,
                type: "video",
              },
            ],
            num: 0,
            section: "Pre Video",
            subSection: "",
            subSectionId: 0,
            template: "prePost_video",
            videoId: pre_video_id,
            loading: false,
          });

          backboneResponse.preVideoId = pre_video_id;
        }

        return Promise.resolve(backboneResponse);
      })
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      });
  }

  /**
   * This method is used by the footer to tell if it can auto jumps to another section.
   *
   * The Keep Play feature only auto advance if the currentIndex is an Instruction or a template which requires user
   * interaction.
   *
   * @returns {boolean}
   */
  isUserInteractionRequired() {
    const indexBlock = this.state.blockIndex;
    const contentIndex = this.state.contentIndex;
    const blocks = this.state.lessonContent && this.state.lessonContent.blocks;
    if (!blocks || !blocks[indexBlock]) return false;
    const template = blocks[indexBlock].template;

    let type = "";
    if (blocks[indexBlock].content) {
      type =
        (blocks[indexBlock].content[contentIndex] &&
          blocks[indexBlock].content[contentIndex].type) ||
        "";
    }

    const isInstruction = type === "instruction";

    //These are interactive templates that the KeepPlaying feature should not automatically advance
    //Check the footer for the KeepPlaying logic
    return (
      DISABLED_KEEP_AND_PLAY_TEMPLATES.includes(template) && !isInstruction
    );
  }

  //TODO this method should be handled by LesssonNavigationContext, and should not depend on template
  playAudio() {
    const computeAudioUrl = () => {
      if (this.isPreVideo()) return "";

      let indexBlock = this.state.blockIndex;
      const _blocks =
        this.state.lessonContent && this.state.lessonContent.blocks;
      if (!_blocks || !_blocks[indexBlock]) return "";
      let type = _blocks[indexBlock].template;
      let content =
        _blocks[indexBlock].content &&
        _blocks[indexBlock].content[this.state.contentIndex];
      let complement = _blocks[indexBlock].complement;
      let skipAudios = [
        "maze",
        "mosaic_2_pt",
        "mosaic_2_en",
        "match",
        "match_the_sentences",
      ];

      if (skipAudios.includes(type)) {
        if (content && content.picture) {
          this._step("forward");
          return;
        }

        if (
          content &&
          type === "match_the_sentences" &&
          content.type === "drill" &&
          !this.state.forceAudio
        ) {
          this._step("forward");
          return;
        }
        if (
          content &&
          type === "maze" &&
          content.type === "drill" &&
          !this.state.forceAudio
        ) {
          this._step("forward");
          return;
        }
      }
      if (type === "match_the_sentences" && this.state.forceComplent) {
        if (this.state.indexComplent < complement.respostas.length) {
          if (isSafariOrIOS()) {
            return getAudioUrl(
              complement["respostas"][this.state.indexComplent].sound_mp3,
            );
          } else {
            return getAudioUrl(
              complement["respostas"][this.state.indexComplent].sound,
            );
          }
        } else {
          this.nextBlock();
        }
      }
      if (
        this.state.lessonContent.blocks[this.state.blockIndex].template ===
        "read_and_match"
      ) {
        return getAudioUrl(this.state.specificUrl);
      }

      let lessonContent = this.state.lessonContent;
      if (
        this.state.lessonContent.blocks[indexBlock].template ===
          "dialog_and_role_play" &&
        this.state.lessonContent.blocks[indexBlock].content.length <= 1
      ) {
        lessonContent.blocks[indexBlock].content = [
          ...lessonContent.blocks[indexBlock].content,
          ...lessonContent.blocks[indexBlock].content[0].sentences,
        ];
        this.setState({ lessonContent });
      }

      if (this.state.lessonContent.blocks[indexBlock].content.length > 0) {
        let notSkipComplement = ["listen_and_drag_to_put_in_order"];
        let audioName = "";
        if (isSafariOrIOS()) {
          if (notSkipComplement.includes(type) && content.type === "drill") {
            audioName = complement.dialog.sound_mp3 || complement.dialog.sound;
            return getAudioUrl(audioName);
          } else {
            audioName = content.sound_mp3 || content.sound;
            return getAudioUrl(audioName);
          }
        } else {
          if (notSkipComplement.includes(type) && content.type === "drill") {
            if (
              !complement ||
              !complement.dialog ||
              (!complement.dialog.sound && !complement.dialog.sound_mp3)
            ) {
              return console.log("Diálogo inexistente. Lendo: ", complement);
            }
            audioName = complement.dialog.sound || complement.dialog.sound_mp3;
            return getAudioUrl(audioName);
          } else {
            audioName = content.sound || content.sound_mp3;
            return getAudioUrl(audioName);
          }
        }
      }
    };

    const computedAudio = computeAudioUrl();

    if (computedAudio && computedAudio !== "") {
      this.setState({ audioUrl: computedAudio });
    }
  }

  onDataReceivedFromChild = (data) => {
    this.setState({
      recordingAttempts: data,
    });
  };

  onVRErrorReceivedFromChild = (vrError) => {
    this.setState({
      vrError: vrError,
    });
  };

  // control show/hide Instant Feedback Modal
  controlInstantFeedback({ currentTemplate, currentBlockIndex }) {
    const { userId, lessonId, bookId, instantFeedback, lessonContent } =
      this.state;
    const { lBook: bookName, lName: lessonName } =
      lessonContent.lessonInfos || {};

    instantFeedback.modalFeedbackProps.instantFeedbackData = {
      userId,
      bookId,
      bookName,
      lessonId,
      lessonName,
    };

    // check when to open Instant Feedback Modal
    if (
      instantFeedback.previousBlockIndex < currentBlockIndex &&
      instantFeedback.enableTemplates.includes(
        instantFeedback.previousTemplate,
      ) &&
      instantFeedback.previousTemplate !== currentTemplate
    ) {
      instantFeedback.modalFeedbackProps.mwShow = true;
    }

    // updates properties of instantFeedbac in state
    instantFeedback.previousTemplate = currentTemplate;
    instantFeedback.previousBlockIndex = currentBlockIndex;
    this.state = { ...this.state, instantFeedback };
  }

  templateSelector(type) {
    let indexBlock = this.state.blockIndex;
    let data =
      this.state.lessonContent.blocks[indexBlock] &&
      this.state.lessonContent.blocks[indexBlock].content &&
      this.state.lessonContent.blocks[indexBlock].content[
        this.state.contentIndex
      ];

    if (
      this.state.lessonContent.blocks[indexBlock] &&
      this.state.lessonContent.blocks[indexBlock].content &&
      this.state.lessonContent.blocks[indexBlock].content.length > 0 &&
      data
    ) {
      data.section = this.state.lessonContent.blocks[indexBlock].section;
      data.section_id = this.state.lessonContent.blocks[indexBlock].sectionId;
      data.book_name =
        this.state.lessonContent.lessonInfos &&
        this.state.lessonContent.lessonInfos.lBook;
    }

    const blockData = this.state.lessonContent.blocks[indexBlock];

    this.controlInstantFeedback({
      currentTemplate: type,
      currentBlockIndex: indexBlock,
    });

    switch (type) {
      case "double_sentence_en":
        return (
          <DoubleSentence
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 1

      case "double_sentence_static_en":
        return (
          <DoubleSentenceStatic
            data={data}
            en={true}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 1

      case "double_sentence_static_pt":
        return (
          <DoubleSentenceStatic
            data={data}
            en={false}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 1

      case "double_sentence_pt":
        return (
          <DoubleSentence
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 2

      case "simple_sentence":
        return (
          <SimpleSentence
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 3

      case "simple_sentence_vr":
        return (
          <SimpleSentenceVr
            data={data}
            lessonName={this.state.lessonContent.lessonInfos.lName}
            contentIndex={this.state.contentIndex}
            callbackExercisesRecordingAttempts={this.onDataReceivedFromChild}
            callbackVRError={this.onVRErrorReceivedFromChild}
            step={(type, force = false) => this._step(type, force)}
            audioUrl={this.state.audioUrl}
            blockIndex={this.state.blockIndex}
            blockData={blockData}
            totalIndexes={this.state.lessonContent.blocks.length}
            lessonId={this.state.lessonId}
          />
        ); // 3

      case "double_sentence_highlighted_en":
        return (
          <DoubleSentenceHL
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 4

      case "simple_text_highlighted":
        return (
          <SimpleTextHL
            blockData={blockData}
            contentIndex={this.state.contentIndex}
          />
        ); // 5

      case "sentences_list":
        return (
          <SentencesList
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 5

      case "speak_right_single":
        return (
          <SpeakRightSingle
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 6

      case "linking_sounds":
        return (
          <LinkingSounds
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "words_in_context_single":
        return (
          <WordsInContext
            data={data}
            double={false}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 8

      case "words_in_context_double":
        return (
          <WordsInContext
            data={data}
            double={true}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 9

      case "web_talk":
        return (
          <WebTalk
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 10

      case "conversation_in_trio":
        return (
          <ConversationInTrio
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 11

      case "conversation_in_two":
        return (
          <ConversationInTwo
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 12

      case "text_dialogues_illustrated":
        return (
          <TextIllustrated
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 13

      case "fluency_in_pairs":
        return (
          <FluencyInPairs
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 14

      case "image_audio":
        return (
          <ImageAudio
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 15

      case "image_subtitle":
        return (
          <ImageSubtitle
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 15

      case "text_pages_illustrated":
        return (
          <TextPagesIllustrated
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 16

      case "mosaic_pt":
        return (
          <Mosaic
            blockData={blockData}
            en={false}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 17

      case "mosaic_en":
        return (
          <Mosaic
            blockData={blockData}
            en={true}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 18

      case "mosaic_2_en":
        return (
          <Mosaic
            blockData={blockData}
            en={true}
            second={true}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 18

      case "mosaic_2_pt":
        return (
          <Mosaic
            blockData={blockData}
            en={false}
            second={true}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 18

      case "irregular_verbs":
        return (
          <IrregularVerbs
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 19

      case "read_and_match":
        return (
          <AppDndProvider>
            <ReadMatch
              bookName={data.book_name}
              totalIndexes={this.state.lessonContent.blocks.length}
              lessonId={this.state.lessonId}
              blockData={blockData}
              blockIndex={this.state.blockIndex}
              step={(type, force = false) => this._step(type, force)}
              togglePlay={() => this._play(false)}
              playSpecific={(sound) => {
                this.setState({ specificUrl: sound });
                this.footer._replay();
              }}
              contentIndex={this.state.contentIndex}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        ); // 20

      case "listen_and_match":
        return (
          <AppDndProvider>
            <ListenMatch
              blockData={blockData}
              lessonId={this.state.lessonId}
              totalIndexes={this.state.lessonContent.blocks.length}
              step={(type) => this._step(type)}
              contentIndex={this.state.contentIndex}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        ); // 21

      case "match":
        return (
          <AppDndProvider>
            <Match
              bookName={data.book_name}
              totalIndexes={this.state.lessonContent.blocks.length}
              lessonId={this.state.lessonId}
              blockData={blockData}
              blockIndex={this.state.blockIndex}
              contentIndex={this.state.contentIndex}
              step={(type, force = false) => this._step(type, force)}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        ); // 22

      case "image_carousel":
        return (
          <Carousel
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 23

      case "single_card":
        return (
          <SingleCard
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 24

      case "irregular_verbs_test_yourself":
        return (
          <IrregularVerbsTestYourself
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 25

      case "speak_right_double":
        return (
          <SpeakRightDouble
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 26

      case "irregular_verbs_3":
        return (
          <IrregularVerbs3
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 27

      case "text_pages_highlighted":
        return (
          <TextPagesHL
            data={data}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        ); // 4

      case "audio":
        return (
          <Audio
            data={data}
            audioUrl={this.state.audioUrl}
            blockData={blockData}
          />
        );

      case "prePost_video":
        return (
          <PrePost
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "text_pages_scrambled":
        return (
          <AppDndProvider>
            <TextPagesScrambled
              blockData={blockData}
              lessonId={this.state.lessonId}
              totalIndexes={this.state.lessonContent.blocks.length}
              contentIndex={this.state.contentIndex}
              step={(type, force) => this._step(type, force)}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        );

      case "workbook":
        return (
          <Workbook
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "dialog_and_role_play":
        return (
          <AppDndProvider>
            <DialogRolePlay
              blockData={blockData}
              contentIndex={this.state.contentIndex}
              audioUrl={this.state.audioUrl}
            />{" "}
          </AppDndProvider>
        );

      case "listen_and_drag_to_put_in_order":
        return (
          <ListenAndDragToPutInOrder
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            step={(type) => this._step(type)}
            lessonId={this.state.lessonId}
            totalIndexes={this.state.lessonContent.blocks.length}
            isPlaying={this.state.isPlaying}
            togglePlay={(play) => this._play(!play)}
            audioUrl={this.state.audioUrl}
          />
        );
      case "put_in_order_word_sentences":
      case "put_in_order_words_sentences":
        return (
          <PutInOrderWord
            blockData={blockData}
            lessonId={this.state.lessonId}
            totalIndexes={this.state.lessonContent.blocks.length}
            step={(type, force) => this._step(type, force)}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "listen_and_choose":
        return (
          <ListenAndChoose
            blockData={blockData}
            step={(type, force) => this._step(type, force)}
            lessonId={this.state.lessonId}
            totalIndexes={this.state.lessonContent.blocks.length}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "maze":
        return (
          <AppDndProvider>
            <Maze
              blockData={blockData}
              step={(type, force) => this._step(type, force)}
              contentIndex={this.state.contentIndex}
              lessonId={this.state.lessonId}
              totalIndexes={this.state.lessonContent.blocks.length}
              setForceAudio={this.setForceAudio}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        );

      case "song":
        return (
          <AppDndProvider>
            <Song
              blockData={blockData}
              contentIndex={this.state.contentIndex}
              datas={this.myConcat(
                blockData.complement.song.lyrics,
                blockData.complement.song.wordsToChange,
              )}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        );

      case "text_dialogue_drag_drop":
        return (
          <AppDndProvider>
            <TextDialogDnD
              step={(type) => this._step(type)}
              blockData={blockData}
              shuffledData={this.shuffle(
                this.getHilighted(
                  this.textDialogConcat(
                    blockData.complement.frases,
                    blockData.complement.palavras,
                  ),
                ),
              )}
              datas={this.textDialogConcat(
                blockData.complement.frases,
                blockData.complement.palavras,
              )}
              audioUrl={this.state.audioUrl}
              lessonId={this.state.lessonId}
              totalIndexes={this.state.lessonContent.blocks.length}
            />
          </AppDndProvider>
        );

      case "lead_in_text":
        return (
          <LeadInText
            blockData={blockData}
            lessonId={this.state.lessonId}
            totalIndexes={this.state.lessonContent.blocks.length}
            contentIndex={this.state.contentIndex}
            step={(type, force) => this._step(type, force)}
            audioUrl={this.state.audioUrl}
          />
        );

      case "match_the_sentences":
        return (
          <AppDndProvider>
            <MatchSentences
              data={data}
              totalIndexes={this.state.lessonContent.blocks.length}
              lessonId={this.state.lessonId}
              blockData={blockData}
              step={(type) => this._step(type)}
              contentIndex={this.state.contentIndex}
              setforceAudio={this.setForceAudio}
              setChecked={this.setChecked}
              checked={this.state.checked}
              blockIndex={this.state.blockIndex}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        );

      case "choose_correct_answer":
        return (
          <ChooseCorrectAnswer
            bookName={data.book_name}
            totalIndexes={this.state.lessonContent.blocks.length}
            lessonId={this.state.lessonId}
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            step={(type, force = false) => this._step(type, force)}
            blockIndex={this.state.blockIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "image_phrase_type":
        return (
          <AppDndProvider>
            <ImagePhraseType
              key={`${this.state.blockIndex}${this.state.lessonId}`}
              blockData={blockData}
              totalIndexes={this.state.lessonContent.blocks.length}
              lessonId={this.state.lessonId}
              step={(type) => this._step(type)}
              shuffledData={this.shuffle(
                this.getHilighted(
                  this.textDialogConcat(
                    blockData.complement.frases,
                    blockData.complement.palavras,
                  ),
                ),
              )}
              datas={this.textDialogConcat(
                blockData.complement.frases,
                blockData.complement.palavras,
              )}
              audioUrl={this.state.audioUrl}
            />
          </AppDndProvider>
        );

      case "video_subtitle":
        return (
          <VideoSubtitle
            paused={!this.state.isPlaying}
            blockData={blockData}
            contentIndex={this.state.contentIndex}
            audioUrl={this.state.audioUrl}
          />
        );

      case "fill_the_blank":
        return (
          <FillTheBlank
            blockData={blockData}
            step={(type) => this._step(type)}
            contentIndex={this.state.contentIndex}
            lessonId={this.state.lessonId}
            totalIndexes={this.state.lessonContent.blocks.length}
            phrases={blockData.complement.frases}
            answer={blockData.complement.palavras}
            audioUrl={this.state.audioUrl}
          />
        );

      default:
        return "No template available";
    }
  }

  myConcat(a, b) {
    let array = a.map(function (item) {
      return item + " - ";
    });
    for (let i = 0; i < b.length; i++) {
      for (let j = 0; j < array.length; j++) {
        if (array[j].includes(b[i])) {
          array[j] = array[j].replace(b[i], "[" + b[i] + "]");
          b = b.filter((m) => {
            return m !== b[i];
          });
          i--;
        }
      }
    }
    return array.join("");
  }

  shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }

  getHilighted(text) {
    let splitText = text.match(/\[(.*?)\]/g);

    let textObj = [];
    for (let i = 0; i < splitText.length; i++) {
      if (splitText[i].includes("[") || splitText[i].includes("]")) {
        textObj.push({
          word: splitText[i].replace("[", "").replace("]", ""),
          lastDroppedItem: null,
        });
      }
    }

    return textObj;
  }

  textDialogConcat(frase, palavras) {
    let PhrasesToSelectCounter = 0;
    let finalArray = frase;
    if (typeof frase !== "string") {
      finalArray = frase.map(function (item) {
        return item + " - ";
      });
    }

    let bracketAmount = 0;
    for (let x = 0; x < frase.length; x++) {
      bracketAmount = frase[x].length - frase[x].replace(/\[/g, "").length;

      if (frase[x].includes("[")) {
        PhrasesToSelectCounter = PhrasesToSelectCounter + bracketAmount;
      }
    }

    if (typeof frase !== "string") {
      finalArray = finalArray.join("");
    }

    for (let j = 0; j < PhrasesToSelectCounter; j++) {
      let value = j + 1;
      let rule = "\\" + "\[" + value + "\\" + "\]";
      let regex = new RegExp(rule, "g");

      finalArray = finalArray.replace(regex, "[" + palavras[j] + "]");
    }
    return finalArray;
  }

  getTenant() {
    const { isEmbedMode } = this.context;
    return isEmbedMode ? "cupheadless" : "cupfranchise";
  }

  // This function will check if the Lesson is complete, and if it is, it will add this Lesson as complete
  // to the BatchProgress collection of the Progress Tracker.
  async checkCompleteness() {
    if (
      this.state.usage &&
      this.state.lessonContent &&
      this.state.lessonContent.blocks &&
      this.state.usage.progress.length ===
        this.state.lessonContent.blocks.length
    ) {
      try {
        const userId = await getUserId();
        const userEmail = await getUserEmail();
        const platformId = await getWizmeId();

        const parsedBatchData = {
          id: this.state.batch
            ? this.state.batch.id
            : Number.parseInt(this.state.lessonContent.lessonInfos.lBookId) *
              -1,
          name: this.state.batch ? this.state.batch.name : "Batchless",
          totalLessons: this.state.batch ? this.state.batch.totalLessons : null,
        };

        const batchData = {
          userId: userId,
          email: userEmail,
          platformId: platformId,
          bookId: this.state.lessonContent.lessonInfos.lBookId,
          bookName: this.state.lessonContent.lessonInfos.lBook,
          batchId: parsedBatchData.id,
          batchName: parsedBatchData.name,
          lessonId: Number.parseInt(this.state.lessonId),
          lessonName: this.state.lessonContent.lessonInfos.lName,
          totalLessons: parsedBatchData.totalLessons,
        };
        const tenant = this.getTenant();
        registerCompleteness(batchData, tenant);
        // This is to ensure the checkCompleteness function is called only once on the EndLesson screen.
        this.setState({
          calledCompletenessCheckOnEndLesson: this.state.endLesson,
        });
      } catch (err) {
        console.log("Couldn't update batch progress: ", err.message);
      }
    }
  }

  async trackUsage() {
    const usage = this.state.usage;
    const endTime = new Date();
    const totalTime =
      endTime - new Date(localStorage.getItem("progress_tracker_start_time"));
    const totalTimeInSeconds = Math.round(totalTime / 1000);
    const userId = await getUserId();
    const email = await getUserEmail();
    const platformId = await getWizmeId();
    const section =
      this.state.lessonContent &&
      this.state.lessonContent.blocks &&
      this.state.lessonContent.blocks[this.state.blockIndex];
    const usageData = {
      userId: userId,
      platformId: platformId,
      lessonId: Number.parseInt(this.state.lessonId),
      email: email,
      lessonName: this.state.lessonContent.lessonInfos.lName,
      bookName: this.state.lessonContent.lessonInfos.lBook,
      progress: [Number.parseInt(this.state.blockIndex)],
      totalSections: this.state.lessonContent.blocks.length,
      totalTime: totalTimeInSeconds,
      sectionName: section ? section.section : null,
    };
    const tenant = this.getTenant();
    if (!usage) {
      // If there is no usage, we need to do a POST
      return createUsage(usageData, tenant);
    } else if (
      !usage.progress.includes(Number.parseInt(this.state.blockIndex))
    ) {
      // We only send a PATCH if the user has not done this block yet
      return updateUsage(usageData, tenant);
    }
    return Promise.reject("User has already done this block.");
  }

  updateUrl(blockIndex) {
    const { isEmbedMode } = this.context;
    const { lessonId } = this.props.match.params;
    const newPath = `${isEmbedMode ? "/embeddable" : ""}/catchupId/1/lesson/${lessonId}/${blockIndex}`;
    this.props.history.push(newPath);
  }

  nextBlock() {
    const nextBlockIndex = parseFloat(this.state.blockIndex) + 1;

    this.trackUsage()
      .catch((error) => {
        console.log("nextBlock error ", error);
      })
      .finally(() => {
        this.setState({
          // avança o Bloco
          contentIndex: 0,
          blockIndex: nextBlockIndex,
          audioUrl: "", // Reset the audio to avoid to play again, on the next rendering, it is computed based on the neu contentIndex and blockIndex
        });
        this.updateUrl(nextBlockIndex);
      });
  }

  advanceToNextBlockOrEndLesson(indexBlock) {
    if (indexBlock < this.state.lessonContent.blocks.length - 1) {
      this.setState({
        indexComplent: 0,
        forceAudio: false,
        forceComplent: false,
      });
      this.nextBlock();
      this.props.match.params.block = parseFloat(indexBlock) + 1;
      return;
    }

    this.trackUsage()
      .catch((error) => {
        console.log("Ops an error at trackUsage :: \n", error);
      })
      .finally(() => {
        this.setState({
          endLesson: true,
          indexComplent: 0,
          forceAudio: false,
          forceComplent: false,
        });
      });
  }

  _step(type, force = false) {
    let indexBlock = this.state.blockIndex;
    const _stepBlocks =
      this.state.lessonContent && this.state.lessonContent.blocks;
    if (!_stepBlocks || !_stepBlocks[indexBlock]) return;
    let template = _stepBlocks[indexBlock].template;
    let forceComplent = this.state.forceComplent;
    let contentIndex = this.state.contentIndex;
    let complement = _stepBlocks[indexBlock].complement;
    let content = _stepBlocks[indexBlock].content;
    const isMosaicTemplate = MOSAIC_TEMPLATES.includes(template);
    const nextInstructionIndex = content.findIndex(
      (item, index) => index > contentIndex && item.type === "instruction",
    );

    const hasNext = contentIndex < content.length - 1;
    const hasNextRespostas =
      this.state.indexComplent > -1 &&
      this.state.hasNextComplent &&
      template === "match_the_sentences";

    let type_exercise;

    if (this.state.lessonContent.blocks[indexBlock].content.length !== 0) {
      type_exercise =
        this.state.lessonContent.blocks[indexBlock].content[contentIndex].type;
    }

    let match_the_sentences_complement =
      !forceComplent &&
      template === "match_the_sentences" &&
      complement &&
      this.state.indexComplent < complement.respostas.length &&
      hasNext;

    if (type === "skipForward") {
      this.props.match.params.block = parseFloat(indexBlock) + 1;
      this.nextBlock();
    } else if (type === "forward") {
      // ir pra frente
      // step block forward if template is read and match

      if (template === "simple_sentence_vr" && type_exercise === "drill") {
        if (this.state.lessonContent.blocks[indexBlock].content.length !== 0) {
          if (
            force === false ||
            (this.state.recordingAttempts === 0 && !this.state.vrError)
          ) {
            return;
          }
        }
      }

      if (template === "read_and_match") {
        if (content[contentIndex].type === "instruction") {
          if (
            this.state.lessonContent.blocks[indexBlock].content.length !== 0
          ) {
            this.setState({
              contentIndex: content.length - 1,
            });
            return;
          }
        }
        this.nextBlock();
        this.props.match.params.block = parseFloat(indexBlock) + 1;
        return;
      }
      if (
        isMosaicTemplate &&
        force &&
        content[contentIndex] &&
        content[contentIndex].type !== "instruction"
      ) {
        if (nextInstructionIndex > -1) {
          this.setState({
            contentIndex: nextInstructionIndex,
            audioUrl: "",
          });
          return;
        }

        this.advanceToNextBlockOrEndLesson(indexBlock);
        return;
      }
      // tratativas pra reproduzir os complementos do template match_the_sentences
      else if (hasNext || match_the_sentences_complement || hasNextRespostas) {
        // avança o content
        if (
          !this.state.hasNextComplent &&
          complement &&
          complement.respostas &&
          complement.respostas.length > 0
        ) {
          this.setState({
            hasNextComplent: true,
          });
        }
        let skipForwardInstruction = [
          "maze",
          "match_the_sentences",
          "listen_and_drag_to_put_in_order",
        ];
        if (
          skipForwardInstruction.includes(template) &&
          content[contentIndex].type === "instruction"
        ) {
          if (template === "listen_and_drag_to_put_in_order") {
            this.setState({
              contentIndex: content.length - 1,
              isPlaying: false,
            });
          } else {
            this.setState({
              contentIndex: content.length - 1,
            });
          }
          return;
        }
        if (force || template !== "match_the_sentences") {
          // Verificando se ele ta pulando instrução do match_the_sentences ou drill
          if (
            template !== "match_the_sentences" &&
            template !== "read_and_match"
          ) {
            this.setState({
              contentIndex: contentIndex + 1,
              audioUrl: "", // Reset the audio to avoid to play again, on the next rendering, it is computed based on the neu contentIndex and blockIndex
            });
          } else if (template === "match_the_sentences") {
            // Verificando se o indexComplent ja foi iniciado
            if (this.state.indexComplent === -1) {
              // Index não foi iniciado, incrementa mais 2 e volta pra coluna da esquerda
              this.setState({
                contentIndex: contentIndex + 1,
                indexComplent: this.state.indexComplent + 2,
                forceComplent: false,
              });
            } else {
              if (!this.state.checked || !content[contentIndex + 1]) {
                this.nextBlock();
              } else {
                // Index ja iniciado, incrementa mais 1 e volta pra coluna da esquerda
                this.setState({
                  contentIndex: contentIndex + 1,
                  indexComplent: this.state.indexComplent + 1,
                  forceComplent: false,
                });
              }
            }
          }
        } else if (
          complement.respostas.length > 0 &&
          this.state.forceAudio &&
          this.state.indexComplent === -1 &&
          template === "match_the_sentences"
        ) {
          this.setState({
            indexComplent: this.state.indexComplent + 1,
            forceComplent: complement.respostas.length > 0,
          });
        } else if (
          complement.respostas.length > 0 &&
          this.state.forceAudio &&
          this.state.indexComplent > 0 &&
          template === "match_the_sentences" &&
          !forceComplent
        ) {
          this.setState({
            forceComplent: !forceComplent,
          });
          if (this.state.indexComplent === complement.respostas.length - 1) {
            this.setState({
              hasNextComplent: false,
            });
          }
        } else if (
          forceComplent &&
          this.state.forceAudio &&
          this.state.hasNextComplent
        ) {
          if (!this.state.checked) {
            this.nextBlock();
          } else {
            this.setState({
              indexComplent: this.state.indexComplent + 1,
              forceComplent: !forceComplent,
              contentIndex: contentIndex + 1,
            });
          }
        }
      } else {
        if (indexBlock < this.state.lessonContent.blocks.length - 1) {
          if (!NOT_SKIP_FORWARD_TEMPLATES.includes(template) || force) {
            this.advanceToNextBlockOrEndLesson(indexBlock);
          }
          return;
        } else if (
          Number.parseInt(indexBlock) ===
          this.state.lessonContent.blocks.length - 1
        ) {
          this.advanceToNextBlockOrEndLesson(indexBlock);
          return;
        }
      }
    } else {
      // para voltar

      if (
        template === "read_and_match" &&
        content[contentIndex].type === "drill" &&
        contentIndex > 0
      ) {
        this.setState({
          contentIndex: 0,
        });
        return;
      }

      if (this.state.contentIndex > 0) {
        this.setState({
          contentIndex: this.state.contentIndex - 1,
          indexComplent: this.state.indexComplent - 1,
        });
      } else {
        if (indexBlock > 0) {
          this.setState({
            contentIndex: 0,
            blockIndex: parseFloat(indexBlock) - 1,
            indexComplent: 0,
            forceAudio: false,
            forceComplent: false,
          });
          this.props.match.params.block = parseFloat(indexBlock) - 1;
          this.updateUrl(parseFloat(indexBlock) - 1);
        }
      }
    }
  }

  _play(varPlay) {
    this.setState({ isPlaying: varPlay });
  }

  setStartTime() {
    const startTime = new Date().toISOString();
    localStorage.setItem("progress_tracker_start_time", startTime);
  }

  async setupUsageProgressTracker() {
    if (!this.state.userId) {
      const userId = await getUserId();
      const platformId = await getWizmeId();
      this.setState({ userId: userId, platformId: platformId });
    }

    if (!this.state.updatedProgressTrackerUsageOnEndLesson) {
      try {
        let tenant = "cupfranchise";
        if (this.context.isEmbedMode) {
          tenant = "cupheadless";
        }
        const usageProgressTrackerData = await getUsageWithFallback(
          this.state.platformId,
          this.props.match.params.lessonId,
          tenant,
        );
        this.setState({
          usage: usageProgressTrackerData.data,
          updatedProgressTrackerUsageOnEndLesson: this.state.endLesson,
        });
      } catch (err) {
        // This means there is no registry of this user in this lesson on the Progress Tracker
        this.setState({ usage: null });
      } finally {
        this.setStartTime();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      blockIndex: nextProps.match.params.block,
      contentIndex: 0,
    });
  }

  componentDidMount() {
    // Code to run only once after the component is mounted
    // It send events to parent component to track the user navigation
    if (this.context.isEmbedMode) {
      const location = this.props.location.pathname;
      let lessonName = localStorage.getItem("lessonName");
      this.context.fireNavigationEvents(location, lessonName);
    }

    const batchData = JSON.parse(localStorage.getItem("batch"));
    if (batchData) {
      this.setState({ batch: batchData });
    }

    getLessonContent(this.props.match.params.lessonId)
      .then((res) => {
        return this.getVideo(this.props.match.params.lessonId, res);
      })
      .then((backboneResponse) => {
        this.setupUsageProgressTracker();
        console.log(backboneResponse);
        this.setState({
          lessonLoading: false,
          lessonContent: backboneResponse,
          lessonError: false,
          bookId: backboneResponse.lessonInfos.lBookId,
          sectionsTotal: backboneResponse.blocks
            ? backboneResponse.blocks.length
            : 0,
          subSectionsTotal:
            (backboneResponse.blocks[0] &&
              backboneResponse.blocks[0].content &&
              backboneResponse.blocks[0].content.length) ||
            0,
        });
      })
      .catch((err) => {
        this.setState({
          lessonLoading: false,
          lessonError: true,
        });
        console.log("getLessonContent ERROR: ", err);
      });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevState.blockIndex !== this.state.blockIndex ||
      (this.state.endLesson && !this.state.calledCompletenessCheckOnEndLesson)
    ) {
      this.setupUsageProgressTracker().finally(() => {
        this.checkCompleteness();
      });
    }

    // Check if the blockIndex or contentIndex has changed, if so, trigger Audio play.
    if (
      prevState.blockIndex !== this.state.blockIndex ||
      prevState.contentIndex !== this.state.contentIndex ||
      prevState.lessonContent != this.state.lessonContent
    ) {
      this.setState({
        subSectionsTotal:
          (this.state.lessonContent.blocks[this.state.blockIndex] &&
            this.state.lessonContent.blocks[this.state.blockIndex].content &&
            this.state.lessonContent.blocks[this.state.blockIndex].content
              .length) ||
          0,
      });

      this.playAudio();
    }
  }

  isPreVideo() {
    return (
      this.state.blockIndex === 0 &&
      this.state.lessonContent &&
      this.state.lessonContent.blocks &&
      this.state.lessonContent.blocks[0] &&
      this.state.lessonContent.blocks[0].template === "prePost_video"
    );
  }

  // Returns the current template once the lesson is done loading.
  // Returns false otherwise.
  getCurrentTemplate() {
    return (
      (!this.state.lessonLoading &&
        !this.state.lessonError &&
        this.state.lessonContent &&
        this.state.lessonContent.blocks &&
        this.state.lessonContent.blocks.length > 1 &&
        this.state.lessonContent.blocks[this.state.blockIndex] &&
        this.state.lessonContent.blocks[this.state.blockIndex].template) ||
      null
    );
  }

  // Returns the CSS class(es) that will be used in the exercise background.
  // It's a temporary function until the whole styling refactoring is done.
  getBackgroundRectangleClasses() {
    switch (this.getCurrentTemplate()) {
      case "maze":
      case "simple_sentence":
      case "simple_text_highlighted":
      case "sentences_list":
      case "audio":
      case "match":
      case "image_audio":
      case "listen_and_drag_to_put_in_order":
      case "put_in_order_words_sentences":
      case "text_dialogues_illustrated":
        return "background-rect background-rect-updated";

      case "prePost_video":
        return "background-rect prepost-video-container-content";

      case "video_subtitle":
        return "background-rect video-subtitle-container-content";

      case "simple_sentence_vr":
        return "";

      case "match_the_sentences":
        return `background-rect ${styles["background-white-default"]}`;

      default:
        return "background-rect";
    }
  }

  render() {
    const { isEmbedMode, fireNavigationEvents } = this.context;

    const { lessonContent, blockIndex, contentIndex } = this.state;

    let content = null;
    if (
      lessonContent &&
      lessonContent.blocks &&
      lessonContent.blocks[blockIndex] &&
      lessonContent.blocks[blockIndex].content &&
      lessonContent.blocks[blockIndex].content[contentIndex]
    ) {
      content = lessonContent.blocks[blockIndex].content[contentIndex].type;
    }

    const { lessonId } = this.props.match.params;
    const { mwShow: mwShowInstantFeedback, instantFeedbackData } =
      this.state.instantFeedback.modalFeedbackProps;

    if (
      this.state.lessonContent &&
      Array.isArray(this.state.lessonContent.blocks)
    ) {
      const { lessonId } = this.props.match.params;
      const { block } = this.props.match.params;
      const { blocks } = this.state.lessonContent;
      const lastBlockIndex = blocks.length - 1;
      if (blocks.length > 0 && block >= blocks.length) {
        let redirectUrl = `/catchupId/1/lesson/${lessonId}/${lastBlockIndex}`;
        this.props.history.push(redirectUrl);
        return <Redirect to={redirectUrl} />;
      }
    } else {
      console.warn(
        "lessonContent or lessonContent.blocks is undefined or not an array",
      );
    }

    return (
      <LessonStateContext
        step={(command, force) => this._step(command, force)}
        isUserInteractionRequired={() => this.isUserInteractionRequired()}
        audioUrl={this.state.audioUrl}
        sectionIndex={this.state.blockIndex}
        subSectionIndex={this.state.contentIndex}
        sectionsTotal={this.state.sectionsTotal}
        subSectionTotal={this.state.subSectionsTotal}
      >
        <ModalFeedback
          // Changing `mwShow` to false because we don't need the InstantFeedback anymore, but in case
          // of future need, we won't be removing the component.
          mwShow={false}
          instantFeedbackData={instantFeedbackData}
          mwClickOutsideToClose={
            this.state.instantFeedback.modalFeedbackProps.mwShow
          }
          mwHandleOnClose={() => {
            this.state.instantFeedback.modalFeedbackProps.mwShow = false;
          }}
        />
        <div>
          {!isEmbedMode && <Header exercise={true} />}

          <div className={!isEmbedMode ? "main" : ""}>
            {!this.state.lessonLoading &&
              !this.state.lessonError &&
              !isEmbedMode && (
                <div
                  style={{
                    position: "fixed",
                    left: 3,
                    top: 5,
                    opacity: 0.6,
                    fontSize: 8,
                    width: "250px",
                    zIndex: 9999,
                  }}
                >
                  <div>Template: {this.getCurrentTemplate()}</div>
                </div>
              )}

            <div className="content" translate="no">
              {!this.state.lessonLoading &&
                !this.state.lessonError &&
                !this.state.endLesson &&
                !(this.state.lessonContent.blocks.length <= 1) && (
                  <LeftNav
                    usageTracker={this.state.usage}
                    data={[
                      this.state.lessonContent.blocks,
                      this.props.match.params,
                    ]}
                  />
                )}
              <div className="background-image content-class">
                <div className={this.getBackgroundRectangleClasses()}>
                  {this.state.lessonLoading ? (
                    <LessonLoader />
                  ) : this.state.lessonError ? ( // if failed to load lesson
                    <div className="warning-center" style={{ left: "40%" }}>
                      <div style={{ marginTop: 10 }}>
                        Error while loading lesson, please try again later.
                      </div>
                    </div>
                  ) : this.state.lessonContent.blocks.length <= 1 ? (
                    <>
                      <div className={styles.container_without_lesson}>
                        <div>
                          <img
                            className={styles.img_illustration}
                            src={noContentIllustration}
                          />
                        </div>
                        <div className={styles.block_phrase}>
                          <p className={styles.without_lesson_phrase}>
                            Oops! Parece que essa lição não está disponível para
                            você.
                          </p>
                          <p>
                            Volte para lista de lições para continuar seus
                            estudos.
                          </p>
                          <Link
                            className={styles.button}
                            to={`${isEmbedMode ? "/embeddable" : ""}/classes/list`}
                          >
                            <ArrowUturnLeftIcon className={styles.icon} />
                            Lições
                          </Link>
                        </div>
                      </div>
                    </>
                  ) : this.state.endLesson ? (
                    <EndLesson
                      lessonId={lessonId}
                      catchupId={this.props.match.params.catchupId}
                    />
                  ) : (
                    this.templateSelector(
                      this.state.lessonContent.blocks[this.state.blockIndex]
                        .template,
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          {!this.state.lessonLoading &&
            !this.state.lessonError &&
            !this.state.endLesson &&
            !(this.state.lessonContent.blocks.length <= 1) && <Footer />}
        </div>
      </LessonStateContext>
    );
  }
}

export default Exercises;
